import { render, staticRenderFns } from "./SetupContext.vue?vue&type=template&id=b160b6a8&scoped=true&"
import script from "./SetupContext.vue?vue&type=script&lang=js&"
export * from "./SetupContext.vue?vue&type=script&lang=js&"
import style0 from "./SetupContext.vue?vue&type=style&index=0&id=b160b6a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b160b6a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b160b6a8')) {
      api.createRecord('b160b6a8', component.options)
    } else {
      api.reload('b160b6a8', component.options)
    }
    module.hot.accept("./SetupContext.vue?vue&type=template&id=b160b6a8&scoped=true&", function () {
      api.rerender('b160b6a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SetupContext.vue"
export default component.exports